module.exports = __webpack_public_path__ + "bbb52052b8dd2a31fdc2eba0d744384e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1024.webp.png
// module id = 465
// module chunks = 0